module.exports = __webpack_public_path__ + "static/accreditations2-a75d8a136779d37d38fa9b7900a01c53.png";